import React from 'react';
import clsx from 'clsx';
import { Tag } from 'lucide-react';

export interface SummaryLineProps {
    label: React.ReactNode;
    value: React.ReactNode;
    kind?: 'line' | 'discount' | 'total';
    /** total value size: 24 (phone) or 28 (panels) */
    large?: boolean;
    className?: string;
}

/** Label / value row for cart, checkout, receipts. */
export const SummaryLine: React.FC<SummaryLineProps> = ({ label, value, kind = 'line', large = false, className }) => {
    if (kind === 'total') {
        return (
            <div className={clsx('flex items-baseline justify-between gap-3 border-t border-line pt-2.5', className)}>
                <span className="text-base font-extrabold">{label}</span>
                <span className={clsx('font-black tnum text-ink-brand', large ? 'text-[28px]' : 'text-2xl')}>{value}</span>
            </div>
        );
    }
    const discount = kind === 'discount';
    return (
        <div className={clsx('flex items-center justify-between gap-3 text-sm', discount ? 'text-success-600' : 'text-ink-secondary', className)}>
            <span className="inline-flex items-center gap-1.5">
                {discount && <Tag className="w-3.5 h-3.5" />}
                {label}
            </span>
            <span className={clsx('tnum', discount ? 'font-extrabold' : 'font-bold')}>{value}</span>
        </div>
    );
};
export default SummaryLine;
